<sb-card (mouseenter)="hover = true" (mouseleave)="hover = false" *ngIf="attachment && attachment.id">
  <div card-fit>
    <div class="d-flex justify-content-end tw-gap-4" style="padding-right: 1rem;padding-top: 1rem;">
      <div>
        <div>{{ 'lang.headlines.folder' |translate }}:</div>
        <div>{{ attachment?.folder?.name ?? '-' }}</div>
      </div>
      <button (dragend)="dragendEmitter.emit()" (dragstart)="dragstartEmitter.emit({event: $event, item: attachment})"
              [draggable]="attachment?.id" class="btn btn-hover-primary">
        <sb-icon icon="drag"></sb-icon>
      </button>
    </div>
    <div class="d-flex justify-content-center align-items-center"
         style="height: 100%;width: 100%;display: flex;flex-direction: column; padding-bottom: 1rem!important;">
      <app-file-dummy [draggedObj]="attachment" [hover]="hover"></app-file-dummy>
    </div>
    <div class="d-flex flex-column align-items-center">
      <div class="d-flex justify-content-between mb-4">
        <ng-container *ngIf="attachment.displayType === 'LINK' && attachment.attachmentType ===  'LINK'">
          <a [href]="attachment.link" class="bigRoundButton mr-1" target="_blank">
            <sb-icon icon="link"></sb-icon>
          </a>
        </ng-container>
        <ng-container *ngIf="attachment.displayType === 'LINK' && attachment.attachmentType ===  'UPLOAD'">
          <a [download]="attachment.fileName" [href]="attachment.fileLink" class="bigRoundButton mr-1"
             target="_blank">
            <sb-icon icon="download"></sb-icon>
          </a>
        </ng-container>
        <ng-container *ngIf="attachment.displayType === 'EMBED' || attachment.displayType ===  'IFRAME'">
          <button (click)="openModal.attachmentShowPreview(attachment)" class="bigRoundButton mr-1">
            <sb-icon icon="preview"></sb-icon>
          </button>
        </ng-container>
        <button (click)="attachmentSelected.emit(attachment);" class="bigRoundButton mx-1">
          <sb-icon icon="details"></sb-icon>
        </button>
        <button (click)="openModal.attachmentLinkAttachmentToEntries(attachment)" class="bigRoundButton ml-1">
          <sb-icon icon="attachmentLink"></sb-icon>
        </button>
      </div>
      <h5 class="mb-0 d-flex justify-content-center"><span
        [innerHTML]="attachment.name | truncate : 25"></span></h5>
      <p>{{ attachment.createdAt?.toString() | date: 'dd.MM.yy HH:mm' }}</p>
    </div>
  </div>
</sb-card>

<sb-card *ngIf="attachment && !attachment.id">
  <div card-fit classes="h-100" style="height: 100%">
    <div class="d-flex justify-content-center align-items-center"
         style="height: 100%;width: 100%;display: flex;flex-direction: column; padding: 3rem;">
      <ng-container *ngIf="attachment.attachmentType === 'UPLOAD'">
        <div style="font-size: 4rem;">
          <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="uploadAltAnimation"></sb-icon>
        </div>
        <h5 class="pt-5 d-flex justify-content-center">
          {{ 'lang.globals.uploadFiles' | translate }}...
        </h5>
      </ng-container>

      <ng-container *ngIf="attachment.attachmentType === 'LINK'">
        <div style="font-size: 4rem;">
          <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="linkAnimation"></sb-icon>
        </div>
        <h5 class="pt-5 d-flex justify-content-center">
          {{ 'lang.globals.processing' | translate }}...
        </h5>
      </ng-container>
    </div>
  </div>
</sb-card>


